"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StreamSourceSelect = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactstrap = require("reactstrap");
var _StreamSourceSelect = require("./StreamSourceSelect.styled");
var _constants = require("../../../constants");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var StreamSourceSelect = exports.StreamSourceSelect = function StreamSourceSelect(_ref) {
  var onSourceTypeChange = _ref.onSourceTypeChange,
    onEmbedCodeChange = _ref.onEmbedCodeChange,
    embedCode = _ref.embedCode,
    sourceType = _ref.sourceType,
    onEdit = _ref.onEdit,
    colorMode = _ref.colorMode,
    adminMode = _ref.adminMode,
    isEditing = _ref.isEditing;
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    showEmbedCodeError = _useState2[0],
    setShowEmbedCodeError = _useState2[1];
  var isBroadcastSource = sourceType === _constants.BROADCAST_SOURCE_TYPE;
  var isEmbededSource = sourceType === _constants.EMBED_SOURCE_TYPE;
  var onEmbedCodeChangeFn = function onEmbedCodeChangeFn(e) {
    var value = e.target.value;
    var trimmed = value.replace(/^\s+/g, ''); // remove the leading spaces
    onEmbedCodeChange(trimmed);
    setShowEmbedCodeError(value === '');
  };
  var onEmbedCodeBlur = function onEmbedCodeBlur() {
    setShowEmbedCodeError(embedCode === '');
  };
  var onSourceTypeChangeFn = function onSourceTypeChangeFn(type) {
    onSourceTypeChange(type);
  };
  var onEditClick = function onEditClick() {
    onEdit(true);
  };
  (0, _react.useEffect)(function () {
    setShowEmbedCodeError(false);
  }, [isEditing]);
  return _react["default"].createElement("div", null, _react["default"].createElement(_StreamSourceSelect.StyledSourceGroup, null, _react["default"].createElement(_StreamSourceSelect.StyledFormLabel, {
    colormode: colorMode
  }, "Stream player source"), _react["default"].createElement(_StreamSourceSelect.StyledCaption, {
    colormode: colorMode
  }, "Select where this theater\u2019s stream player will ingest content from.")), _react["default"].createElement(_StreamSourceSelect.StyledCheckGroup, {
    adminmode: adminMode
  }, _react["default"].createElement(_StreamSourceSelect.StyledCheckLabel, {
    colormode: colorMode,
    check: true,
    htmlFor: "broadcast-check"
  }, _react["default"].createElement(_reactstrap.Input, {
    onChange: function onChange() {
      return onSourceTypeChangeFn(_constants.BROADCAST_SOURCE_TYPE);
    },
    checked: isBroadcastSource,
    id: "broadcast-check",
    "data-testid": "broadcast-check",
    type: "radio"
  }), "Shoflo Studio"), _react["default"].createElement("br", null), _react["default"].createElement(_StreamSourceSelect.StyledCheckLabel, {
    colormode: colorMode,
    check: true,
    htmlFor: "embed-check"
  }, _react["default"].createElement(_reactstrap.Input, {
    onChange: function onChange() {
      return onSourceTypeChangeFn(_constants.EMBED_SOURCE_TYPE);
    },
    checked: isEmbededSource,
    id: "embed-check",
    "data-testid": "embed-check",
    type: "radio"
  }), "3rd party player (Vimeo/YouTube)")), isEmbededSource && adminMode ? _react["default"].createElement(_StreamSourceSelect.Flex, null, _react["default"].createElement(_StreamSourceSelect.StyledCheckLabel, null, "Player embed code"), !isEditing && _react["default"].createElement(_StreamSourceSelect.EditCodeButton, {
    "data-testid": "edit-embed-code",
    onClick: onEditClick
  }, "Edit")) : null, isEmbededSource && _react["default"].createElement(_reactstrap.FormGroup, null, _react["default"].createElement(_StreamSourceSelect.StyledInput, {
    type: "textarea",
    "data-testid": "stream-embed-code",
    id: "stream-embed-code",
    placeholder: "e.g. <div>player embed code goes here</div>",
    value: embedCode,
    onChange: onEmbedCodeChangeFn,
    onBlur: onEmbedCodeBlur,
    invalid: showEmbedCodeError,
    disabled: adminMode && !isEditing
  }), showEmbedCodeError && _react["default"].createElement(_reactstrap.FormFeedback, null, "Uh oh! Embed code is required.")));
};
StreamSourceSelect.defaultProps = {
  onEdit: function onEdit() {
    return null;
  },
  colorMode: 'light',
  adminMode: false,
  isEditing: false
};
StreamSourceSelect.propTypes = {
  onSourceTypeChange: _propTypes["default"].func.isRequired,
  onEmbedCodeChange: _propTypes["default"].func.isRequired,
  embedCode: _propTypes["default"].string.isRequired,
  sourceType: _propTypes["default"].string.isRequired,
  onEdit: _propTypes["default"].func,
  colorMode: _propTypes["default"].oneOf(['light', 'dark']),
  adminMode: _propTypes["default"].bool,
  isEditing: _propTypes["default"].bool
};